/** The shell scrolls main on desktop and the document on mobile. */
export function workspaceScrollParent(element: HTMLElement): HTMLElement | null {
  const win = element.ownerDocument.defaultView;
  if (!win) return null;
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    if (/^(auto|scroll|hidden)$/.test(win.getComputedStyle(parent).overflowY)) return parent;
  }
  return null;
}

/** Unlike scrollIntoView, move only the owning scroller, never all ancestors. */
export function scrollWorkspaceTarget(target: HTMLElement, margin?: number) {
  const win = target.ownerDocument.defaultView;
  if (!win) return;
  const offset = margin ?? (Number.parseFloat(win.getComputedStyle(target).scrollMarginTop) || 0);
  const container = workspaceScrollParent(target);
  const top = target.getBoundingClientRect().top;
  if (container) {
    container.scrollTo({
      top:
        container.scrollTop +
        top -
        container.getBoundingClientRect().top -
        container.clientTop -
        offset,
      behavior: "instant",
    });
  } else {
    win.scrollTo({ top: win.scrollY + top - offset, behavior: "instant" });
  }
}
